
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manufacturing",
      function () {
        return require("private-next-pages/manufacturing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manufacturing"])
      });
    }
  